import { render, staticRenderFns } from "./solutionDetails11.vue?vue&type=template&id=8505a40c&scoped=true&"
import script from "./solutionDetails11.vue?vue&type=script&lang=js&"
export * from "./solutionDetails11.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails11.vue?vue&type=style&index=0&id=8505a40c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505a40c",
  null
  
)

export default component.exports